import urlParse from 'url-parse';
import axiosNonAuth from '../api/axiosNonAuth';

/**
 * Iframe ID used for sending events between parent window and capmaign iframes
 */
export function getFrameId(rendererId, cardId, campaignId) {
  return `${campaignId}-${rendererId}-${cardId || null}`;
}

/**
 * Used in capmaign-based Iframe Ad rotation
 */
export function saveLastMountedRendererToken(campaignId, rendererToken) {
  window.localStorage.setItem(`vup-campaign-${campaignId}-mounted-renderer`, rendererToken);
}

/**
 * Used in capmaign-based Iframe Ad rotation
 */
export function readLastMountedRendererToken(campaignId) {
  return window.localStorage.getItem(`vup-campaign-${campaignId}-mounted-renderer`);
}

/**
 * Ad iframe uses two-level iframe
 */
export function getAdHostingWindow() {
  return window.parent.parent;
}

export function interpolateAdSourceWithTrackingId(adSource, adTrackingId) {
  if (!adSource || !adTrackingId) return adSource;

  if (adSource.useIframe) {
    // using iframe - pass adTrackingId as url GET param to iframe endpoint
    const {iframeUrl, iframeCodeTemplate} = adSource;
    const parsedUrl = urlParse(iframeUrl, true);
    const {query} = parsedUrl;
    query.adTrackingId = encodeURIComponent(adTrackingId);
    parsedUrl.set('query', query);
    return {
      ...adSource,
      adCode: interpolateIframeCode(iframeCodeTemplate, parsedUrl.toString())
    };
  }

  // not using iframe - interpolate adCode directly
  return {
    ...adSource,
    adCode: interpolateAdSourceCodeWithTrackingId(adSource.adCode, adTrackingId)
  };
}

/**
 * Used with PrgrammaticAdSource configurations
 */
 export function interpolateAdSourceCodeWithTrackingId(templateText, adTrackingId) {
  const trackingIdPlaceholder = '{{adTrackingId}}';

  if (!templateText.includes(trackingIdPlaceholder)) {
    return templateText;
  }
 return templateText.replace(trackingIdPlaceholder, adTrackingId || trackingIdPlaceholder);
}

/**
 * [soon deprecated] used with AdTemplate configurations
 */
export function interpolateAdTemplateWithTrackingId(templateText, adTrackingId) {
  const trackingIdPlaceholder = '{ad_tracking_id}';

  if (!templateText.includes(trackingIdPlaceholder)) {
    return templateText;
  }
 return templateText.replace(trackingIdPlaceholder, adTrackingId || trackingIdPlaceholder);
}

export function interpolateIframeCode(templateText, iframeUrl) {
  const iframeUrlPlaceholder = '{iframe_url}';

  if (!templateText.includes(iframeUrlPlaceholder)) {
    return templateText;
  }
 return templateText.replace(iframeUrlPlaceholder, iframeUrl || iframeUrlPlaceholder);
}

export function getPublisherSpecificIframeUrl(iframeUrl, publisherId) {
  const parsed = urlParse(iframeUrl, true);
  const {query} = parsed;
  query.publisherId = publisherId || 0;
  parsed.set('query', query);
  return parsed.toString();
}

export async function fetchAdIframeUrl(iframeUrl) {
  const response = await axiosNonAuth.get(iframeUrl);
  return response.status;
}